import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { MorningRegisterFormSchema, type MorningRegisterFormValues } from './MorningRegisterFormSchema';
import { MorningRegistrationFooter, MorningRegistration } from './components';

export const RegisterToMorningComponents: FormDrawerProps<ZodSchema<MorningRegisterFormValues>> = {
  zodSchema: MorningRegisterFormSchema,
  ContentComponent: MorningRegistration,
  Footer: MorningRegistrationFooter,
};